<template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>

    <vue-snotify></vue-snotify>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    //
  }),
};
</script>
<style>
.app-border-blue {
  border: 2px solid blue;
}

.app-border-red {
  border: 2px solid red;
}

.app-hover-pointer:hover {
  cursor: pointer;
}

.app-hover-scale:hover {
  transform: scale(1.1);
}

.app-transition-ease {
  transition: all ease 0.2s;
}

.app-center-both {
  display: flex;
  justify-content: center;
  align-items: center;
}

.app-w-100 {
  width: 100%;
}

.app-h-100 {
  height: 100%;
}

.app-center-x {
  display: flex;
  justify-content: center;
}

/* Hides the element if it is empty */
.slot:is(:empty) {
  display: none;
}

.width-100 {
  width: 100%;
}

.height-100 {
  height: 100%;
}

.user-select-none {
  user-select: none;
}
</style>
